import _extends from '@babel/runtime/helpers/esm/extends';
import React from 'react';
import { aggregatedClasses } from '@elliemae/ds-classnames';
import DSButton from '@elliemae/ds-basic/Button';
import CloseCircle from '@elliemae/ds-icons/CloseCircle';
import ArrowShortRight from '@elliemae/ds-icons/ArrowShortRight';
import ArrowShortReturn from '@elliemae/ds-icons/ArrowShortReturn';

var ActionButton = aggregatedClasses(DSButton)('shuttle-list-item', 'action-button');
var DeleteButton = function DeleteButton(props) {
  return /*#__PURE__*/React.createElement(ActionButton, _extends({
    buttonType: "text",
    icon: /*#__PURE__*/React.createElement(CloseCircle, null)
  }, props));
};
var MoveButton = function MoveButton(props) {
  return /*#__PURE__*/React.createElement(ActionButton, _extends({
    buttonType: "text",
    icon: /*#__PURE__*/React.createElement(ArrowShortRight, null)
  }, props, {
    containerProps: {
      'data-testid': 'ds-shuttle__move-button'
    }
  }));
};
var DrillDownButton = function DrillDownButton(props) {
  return /*#__PURE__*/React.createElement(ActionButton, _extends({
    buttonType: "text",
    icon: /*#__PURE__*/React.createElement(ArrowShortReturn, {
      "data-testid": "shuttle__drill-btn-icon"
    })
  }, props, {
    containerProps: {
      'data-testid': 'shuttle__drill-btn'
    }
  }));
};

export { DeleteButton, DrillDownButton, MoveButton };
//# sourceMappingURL=ActionButtons.js.map
